// ROUTES
import { ROUTE_IIRGD } from 'routes/paths';

export const ROUTE_IIRGD_CONSULTAR_CPF = `${ROUTE_IIRGD}/cpf/consultar`;
export const ROUTE_IIRGD_CONSULTAR_RESULTADO = `${ROUTE_IIRGD}/cpf/resultado`;
